import { Dictionary, isEmpty } from 'lodash';
import {
  RedactedWords,
  TranscriptionViewable,
  TranscriptionViewableWords,
} from '../common-app/state/modules/mediaDetails/models';
import { findContiguousWords } from '../redact-app/components/Transcription/utils';
import {
  MEDIA_EXTENSIONS,
  PUNCTUATION_REGEX,
  TRANSCRIPTION_ELLIPSIS_MIN_DURATION_MS,
} from '../helpers/constants';

export const getRedactedTranscript = (
  redactedWords: Dictionary<RedactedWords | undefined>,
  transcription: TranscriptionViewable | undefined
): string => {
  const len = (t: TranscriptionViewableWords) => t.stopTimeMs - t.startTimeMs;
  type Is = (
    w: TranscriptionViewableWords | undefined
  ) => w is TranscriptionViewableWords;
  const isRed: Is = (w): w is TranscriptionViewableWords =>
    !!w && !!redactedWords[w.id];
  const filteredTranscription = (transcription?.transcription || []).filter(
    (t) => !t.isSpacer || len(t) >= TRANSCRIPTION_ELLIPSIS_MIN_DURATION_MS
  );

  let redactedText = '';

  const contiguousWordsMap: string[] = [];

  filteredTranscription.forEach((word) => {
    // Note: If included in word map then it has already been used
    if (contiguousWordsMap.includes(word.id)) {
      return;
    }

    // Building Redacted Text
    const redactedWordObj = redactedWords[word.id];
    let redactedWord = redactedWords[word.id]?.words || word.words;
    if (redactedWords[word.id]) {
      const contiguous = findContiguousWords(
        filteredTranscription,
        word,
        isRed
      );
      let contiguousDuration = 0;
      if (contiguous.length) {
        contiguousDuration =
          (contiguous.at(-1)!.stopTimeMs - contiguous[0]!.startTimeMs) / 1000;
      }
      contiguous.forEach((w) => contiguousWordsMap.push(w.id));

      if (redactedWordObj) {
        if (redactedWordObj.editDetails?.redactionCode) {
          redactedWord = `[${redactedWordObj.editDetails?.redactionCode.code}]`;
        } else if (
          redactedWordObj.editDetails?.labels &&
          !isEmpty(redactedWordObj.editDetails?.labels)
        ) {
          redactedWord = `[${redactedWordObj.editDetails?.labels.join(',')}]`;
        } else {
          if (contiguousDuration < 3) {
            redactedWord = '[REDACTED]';
          } else {
            // add . for each second of redaction
            redactedWord = '[REDACTED' + '.'.repeat(contiguousDuration) + ']';
          }
        }
      }
    }
    if (word.words.match(PUNCTUATION_REGEX)) {
      redactedText += redactedWord;
    } else {
      const spaceChar = redactedText.length ? ' ' : '';
      redactedText += spaceChar + redactedWord;
    }
  });

  return redactedText;
};

export const removeMediaExtension = (filename: string) => {
  const extension = MEDIA_EXTENSIONS.find((ext) =>
    filename.toLowerCase().endsWith(ext)
  );
  return extension ? filename.slice(0, -extension.length) : filename;
};
